import React from "react";

import Styles from "./ProductError.styles";
import { ProductErrorProps as Props } from "./ProductError.types";
import Button from "components/global/Button/Button";
import CONSTANTS from "config/constants";

import ErrorSVG from "../../../../public/assets/images/product-error.svg";

const { WITH_PRODUCT_MODAL } = CONSTANTS.FEATURE_FLAGS;

const ProductError: React.FC<Props> = props => {
  const refreshPage = () => {
    if (typeof window === "undefined") return;
    window.location.reload();
  };

  return (
    <Styles className="ProductError" isModal={WITH_PRODUCT_MODAL}>
      <div className="ProductError__error-state">
        <div className="ProductError__error-state__icon">
          <ErrorSVG />
        </div>
        <p className="ProductError__error-state__title">
          Hubo un error al cargar el producto
        </p>
        <p className="ProductError__error-state__description">
          Intenta recargar la página para poder visualizarlo
        </p>
        <Button
          className="ProductError__error-state__button"
          onClick={refreshPage}
        >
          Explorar más productos
        </Button>
      </div>
    </Styles>
  );
};

ProductError.defaultProps = {};

export default ProductError;
